<div class="dropleft filter-dropdown" ngbDropdown #myDrop="ngbDropdown" autoClose="outside">
  <button class="btn btn-secondary " style="width: 84px;" ngbDropdownToggle>
    <img style="display: inline" src="assets/media/icons/svg/filter-tool.svg" width="16px" class="mr-2">
    <span>{{ 'FILTERS.FILTER' | translate }}</span>
  </button>
  <div class="advanced-filter" ngbDropdownMenu>
    <span style="padding: 0 18px" class="main-title-16">{{ 'FILTERS.FILTER' | translate }}</span>
    <div class="dropdown-divider"></div>
    <div>
      <filters [filterOptions]="filterOptions" [selectedFilters]="selectedFilters" [savedFilters]="savedFilters"
        (applied)="applied.emit($event); myDrop.close()" (saved)="saved.emit($event); myDrop.close()"></filters>
    </div>
  </div>
</div>